import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onMounted } from 'vue';
import axios from 'axios';
import type { ArticleV1 } from '@ilteducation/content-registry-types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ArticlesWithoutAudioDataTable',
  setup(__props, { expose }) {

const articleListUrl = process.env.VUE_APP_ARTICLES_API_URL_LIST;
const articles = ref<ArticleV1[]>([]);
const selectedArticles = ref<ArticleV1[]>([]);
const totalItems = ref(0);
const loading = ref(false);
const options = ref({ page: 1, itemsPerPage: 10 });
const search = ref('');

let searchDebounceTimer: ReturnType<typeof setTimeout> | null = null;

expose({ selectedArticles });

const fetchArticles = async () => {
  loading.value = true;
  try {
    const { page, itemsPerPage } = options.value;
    const params = new URLSearchParams({
      sort: 'lastUpdatedAt:desc',
      filter: 'not-exists:audio',
      'pagination[page]': String(page),
      'pagination[perPage]': String(itemsPerPage),
    });
    if (search.value) params.set('q', search.value);
    const response = await axios.get(`${articleListUrl}?${params}`);
    articles.value = response.data.data;
    totalItems.value = response.data.total ?? 0;
  } catch (error) {
    console.error('Error fetching articles without audio:', error);
  } finally {
    loading.value = false;
  }
};

onMounted(fetchArticles);
watch(options, fetchArticles, { deep: true });
watch(search, () => {
  if (searchDebounceTimer) clearTimeout(searchDebounceTimer);
  searchDebounceTimer = setTimeout(() => {
    options.value.page = 1;
    fetchArticles();
  }, 300);
});

const headers = [
  { text: 'ID', value: 'id' },
  { text: 'Headline', value: 'headline' },
  { text: 'Author', value: 'author' },
  { text: 'Publisher', value: 'publisher' },
  { text: 'Audio', value: 'audio' },
  { text: 'Created', value: 'createdAt' },
];

return { __sfc: true,articleListUrl, articles, selectedArticles, totalItems, loading, options, search, searchDebounceTimer, fetchArticles, headers }
}

})